const $ = window.jQuery;
import _ from 'lodash';

$(() => {
    const $card_feeds = $('.card-feed');

    _.each($card_feeds, card_feed => {
        const $card_feed = $(card_feed);
        const $container = $card_feed.find('.card-feed__cards').first();
        const $view_more = $card_feed.find('.card-feed__more-button').first();

        const post_url = $card_feed.attr('data-post-url');
        const card_url = $card_feed.attr('data-card-url');
        const offset = $card_feed.attr('data-offset');
        const start = $card_feed.attr('data-start-date');

        $view_more.on('click', () => {
            let page = parseInt($card_feed.attr('data-page'));
            let body = { page };

            if (start) {
                body = { page, start };
            }

            $card_feed.addClass('card-feed--loading');

            $.post(`${post_url}${offset}`, body).done(cards => {
                $.post(card_url, { cards }).done(html => {
                    $container.append(html);
                    $card_feed.attr('data-page', page + 1);
                    $card_feed.removeClass('card-feed--loading');
                });

                if( cards.length === 0 ) {
                    $view_more.parent().remove();
                }
            });
        });
    });
});
